<template>
    <section
        class="scc-hero"
        :class="[`scc-hero-negative-margin-${negativeMargin}`, !title ? 'scc-hero--no-title' : null]"
        :style="style"
    >
        <component :is="titleTag" v-if="title" class="scc-hero__title">{{ title }}</component>
    </section>
</template>

<script>
import './hero.scss';

import Heading from './Heading';

export default {
    name: 'Hero',
    components: { Heading },
    __editor: {
        fields: {
            titleTag: {
                widget: 'select',
                values: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p'],
            },
            image: {
                widget: 'media',
            },
            negativeMargin: {
                widget: 'select',
                values: ['none', 'small', 'medium', 'large'],
            },
            imageSize: {
                widget: 'select',
                values: ['auto', 'cover', 'contain'],
            },
            imagePositionX: {
                widget: 'select',
                values: ['left', 'center', 'right'],
            },
            imagePositionY: {
                widget: 'select',
                values: ['top', 'center', 'bottom'],
            },
            imageOpacity: {
                widget: 'slider',
                values: {
                    min: 0,
                    max: 100,
                },
            },
        },
    },
    props: {
        title: {
            type: String,
        },
        titleTag: {
            type: String,
            default: 'h1',
        },
        image: {
            type: String,
            default:
                'https://images.unsplash.com/photo-1550534790-5724c29d08f1?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1500&q=80',
        },
        negativeMargin: {
            type: String,
            default: 'none',
        },
        imageSize: {
            type: String,
            default: 'cover',
        },
        imagePositionX: {
            type: String,
            default: 'center',
        },
        imagePositionY: {
            type: String,
            default: 'center',
        },
        imageOpacity: {
            type: Number,
            default: 100,
        },
    },
    computed: {
        style() {
            return `
                background-image: url('${this.image}');
                background-size: ${this.imageSize};
                background-position: ${this.imagePositionX} ${this.imagePositionY};
                opacity: ${this.imageOpacity}%;
            `;
        },
    },
};
</script>
